<template>
  <div v-if="show" class="modal-backdrop-no-close">
    <div class="modal-content-custom">
      <header class="modal-header-custom">
        <h2 class="modal-title">
          Bienvenue dans la nouvelle version !
        </h2>
      </header>

      <div class="welcome-content">
        <div class="welcome-header">
          <svg
            class="welcome-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor" />
            <path d="M12 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2v-4c0-1.1-.9-2-2-2z" fill="currentColor" />
          </svg>
          <h3>Veuillez accepter les conditions d'utilisation</h3>
        </div>

        <div class="welcome-text">
          <!-- Texte V2 + complément Kevin (placeholder) -->
          <div class="v2-content">
            <h4>Conditions d'utilisation :</h4>
            <p class="v2-text">
              La présente plateforme étant mise en place avec la participation financière du groupe AGCO, l’utilisateur s'engage à ne pas utiliser LisaPrint afin de faire la promotion de produits ou marques concurrentes aux gammes de produits Core et produits complémentaires référencés.
            </p>
            <p class="v2-text">
              <strong style="color: red;">AGCO</strong> se réserve le droit de modifier, suspendre ou interrompre l'accès à la plateforme à tout moment. Et de consulter les données des utilisateurs pour garantir le respect des conditions d'utilisation.
            </p>
          </div>

          <div class="tips-section">
            <h4>💡 Conseils pour bien commencer :</h4>
            <ul>
              <li>Explorez le nouveau tableau de bord pour vous familiariser</li>
              <li>Consultez vos documents dans la section dédiée</li>
              <li>Testez les nouveaux outils de création de supports</li>
              <li>N'hésitez pas à nous contacter si vous avez des questions</li>
            </ul>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn-primary" @click="handleValidate">
            J'accepte et je continue
          </button>
        </div>
      
        <div class="rgpd-notice">
          <p class="text-xs text-gray-500 text-center">
            En continuant, vous acceptez les conditions d'utilisation de cette nouvelle version.
            Cette information peut être reconsultée à tout moment via l'icône en bas de votre écran.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { defineEmits, defineProps } from '@vue/runtime-core';

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'validate'): void
}>()

const handleValidate = () => {
  // Émettre l'événement validate pour que le parent gère l'acceptation des termes
  emit('validate')
}
</script>

<style scoped>
.modal-backdrop-no-close {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content-custom {
  background: #fff;
  border-radius: 12px;
  max-width: 700px;
  width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header-custom {
  padding: 2rem 2rem 1rem 2rem;
  text-align: center;
  border-bottom: 2px solid #B70018;
}

.modal-title {
  color: #B70018;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.welcome-content {
  padding: 2rem;
  max-height: 60vh;
  overflow-y: auto;
}

.welcome-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e5e5;
}

.welcome-icon {
  width: 3rem;
  height: 3rem;
  color: #B70018;
}

.welcome-header h3 {
  color: #333;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.welcome-text {
  line-height: 1.6;
}

.welcome-text p {
  margin-bottom: 1rem;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 1rem 0;
}

.feature-list li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
}

.v2-content {
  background: #f8f9fa;
  border-left: 4px solid #B70018;
  padding: 1rem;
  margin: 1.5rem 0;
  border-radius: 4px;
}

.v2-content h4 {
  color: #B70018;
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
}

.v2-text, .kevin-complement {
  font-style: italic;
  color: #666;
  background: white;
  padding: 0.75rem;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin-bottom: 1rem;
}

.tips-section {
  background: #e8f5e8;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1.5rem;
}

.tips-section h4 {
  color: #2d5a2d;
  margin-top: 0;
  margin-bottom: 0.75rem;
}

.tips-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tips-section li {
  padding: 0.25rem 0;
  color: #2d5a2d;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e5e5;
}

.rgpd-notice {
  margin-top: 1rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
}

.btn-secondary {
  padding: 0.75rem 1.5rem;
  border: 1px solid #ccc;
  background: white;
  color: #666;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background: #f5f5f5;
  border-color: #999;
}

.btn-primary {
  padding: 0.75rem 1.5rem;
  background: #B70018;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-primary:hover {
  background: #960014;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(183, 0, 24, 0.2);
}

.btn-primary:active {
  transform: translateY(0);
}
</style>